export const contactTranslations = {
  fr: {
    hero: {
      title: 'Contactez-moi',
      subtitle: 'Je suis là pour répondre à toutes vos questions'
    },
    
    info: {
      title: 'Informations de contact',
      email: 'Email',
      phone: 'Téléphone',
      website: 'Site web',
      consultations: 'Consultations',
      consultationsText: 'Ibiza en présentiel et à distance partout dans le monde'
    },
    
    form: {
      title: 'Envoyez-moi un message',
      subtitle: 'Remplissez ce formulaire et je vous recontacte rapidement',
      name: 'Nom complet',
      email: 'Email',
      message: 'Votre message',
      messagePlaceholder: 'Parlez-moi de votre situation et de ce que vous recherchez...',
      button: 'Envoyer ma demande',
      success: 'Message envoyé !',
      successMessage: 'Merci pour votre message. Je reviendrai vers vous sous 24h.',
      messageHint: 'Votre message doit contenir au moins 10 caractères.',
      consentBefore: 'J\'accepte que mes données soient utilisées afin de traiter ma demande et d\'être recontacté(e) conformément à la ',
      consentLink: 'Politique de confidentialité',
      consentAfter: '.',
      consentError: 'Merci d\'accepter la politique de confidentialité pour continuer.',
      errorShortMessage: 'Votre message est trop court. Merci d\'écrire au moins 10 caractères.',
      errorGeneric: 'Une erreur est survenue. Veuillez vérifier vos informations et réessayer.'
    },
    
    faq: {
      title: 'Questions fréquentes',
      q1: {
        question: 'Comment se déroule une séance ?',
        answer: 'Les consultations se déroulent en visioconférence Zoom ou en présentiel à Ibiza selon vos préférences. Chaque séance est un espace d\'écoute bienveillant et confidentiel.'
      },
      q2: {
        question: 'Combien de temps dure une séance ?',
        answer: 'La première consultation découverte dure 30 minutes gratuitement. Les séances complètes durent généralement entre 60 et 90 minutes selon le type d\'accompagnement.'
      },
      q3: {
        question: 'À qui s\'adressent vos services ?',
        answer: 'Je reçois des personnes seules, des couples et des familles qui traversent une période de questionnement, de changement ou qui souhaitent mieux se comprendre pour avancer dans leur vie.'
      },
      q4: {
        question: 'Combien de séances sont nécessaires ?',
        answer: 'Cela dépend de vos besoins et de vos objectifs. Certaines personnes trouvent des réponses dès la première séance, d\'autres préfèrent un accompagnement plus régulier. Nous en discutons ensemble lors de notre première rencontre.'
      }
    },
    
    cta: {
      title: 'Prêt(e) à échanger ensemble ?',
      button: 'Prendre rendez-vous'
    }
  },
  
  es: {
    hero: {
      title: 'Contáctame',
      subtitle: 'Estoy aquí para responder a todas tus preguntas'
    },
    
    info: {
      title: 'Información de contacto',
      email: 'Email',
      phone: 'Teléfono',
      website: 'Sitio web',
      consultations: 'Consultas',
      consultationsText: 'Ibiza presencial y online en todo el mundo'
    },
    
    form: {
      title: 'Envíame un mensaje',
      subtitle: 'Rellena este formulario y te contactaré rápidamente',
      name: 'Nombre completo',
      email: 'Email',
      message: 'Tu mensaje',
      messagePlaceholder: 'Háblame de tu situación y de lo que buscas...',
      button: 'Enviar mi solicitud',
      success: '¡Mensaje enviado!',
      successMessage: 'Gracias por tu mensaje. Te responderé en menos de 24h.',
      messageHint: 'Tu mensaje debe contener al menos 10 caracteres.',
      consentBefore: 'Acepto que mis datos sean utilizados para tramitar mi solicitud y poder ser contactado(a) de acuerdo con la ',
      consentLink: 'Política de Privacidad',
      consentAfter: '.',
      consentError: 'Por favor acepta la política de privacidad para continuar.',
      errorShortMessage: 'Tu mensaje es demasiado corto. Por favor escribe al menos 10 caracteres.',
      errorGeneric: 'Ha ocurrido un error. Por favor verifica tus datos e inténtalo de nuevo.'
    },
    
    faq: {
      title: 'Preguntas frecuentes',
      q1: {
        question: '¿Cómo se desarrolla una sesión?',
        answer: 'Las consultas se realizan en videoconferencia Zoom o presencial en Ibiza según tus preferencias. Cada sesión es un espacio de escucha afectuoso y confidencial.'
      },
      q2: {
        question: '¿Cuánto dura una sesión?',
        answer: 'La primera consulta descubrimiento dura 30 minutos gratuitamente. Las sesiones completas duran generalmente entre 60 y 90 minutos según el tipo de acompañamiento.'
      },
      q3: {
        question: '¿A quién se dirigen tus servicios?',
        answer: 'Recibo a personas solas, parejas y familias que atraviesan un período de cuestionamiento, cambio o que desean comprenderse mejor para avanzar en su vida.'
      },
      q4: {
        question: '¿Cuántas sesiones son necesarias?',
        answer: 'Depende de tus necesidades y objetivos. Algunas personas encuentran respuestas desde la primera sesión, otras prefieren un acompañamiento más regular. Lo hablamos juntos durante nuestro primer encuentro.'
      }
    },
    
    cta: {
      title: '¿List@ para hablar juntos?',
      button: 'Reservar cita'
    }
  }
};